var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H17V4.09581C16.4589 4.19085 15.9674 4.48459 15.6129 4.9248C15.2583 5.36501 15.0638 5.92316 15.0638 6.5C15.0638 7.07684 15.2583 7.63499 15.6129 8.0752C15.9674 8.51541 16.4589 8.80915 17 8.90419V13H0V8.90419C0.541596 8.80965 1.03371 8.51608 1.38871 8.07573C1.74371 7.63539 1.93855 7.07686 1.93855 6.49959C1.93855 5.92233 1.74371 5.3638 1.38871 4.92345C1.03371 4.48311 0.541596 4.18953 0 4.095V0ZM11.5909 5.6875V4.0625H5.40909V5.6875H11.5909ZM11.5909 8.9375V7.3125H5.40909V8.9375H11.5909Z",
    fill: "#F0E1CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.3a99f6a7b15730b9b66ef892380a26fc.svg";
export { ForwardRef as ReactComponent };